// Merges accessor objects WITHOUT evaluating getters (object spread would
// invoke them while the form model is still { data: null }).
export const mergeAccessors = <T extends object, U extends object>(target: T, source: U): T & U =>
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) as T & U;
